module.exports = __webpack_public_path__ + "img/gift-friend-bottom.16ff8263.png";